import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import { useDispatch, useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import he from "date-fns/locale/he";
import { format } from "date-fns";
import { parseISO } from "date-fns";
import AddMoving from "./AddMoving";
import MainBtn from "../repeats/mainBtn/MainBtn";
import Pros from "../pros/Pros";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/Footer";
import ItemList from "../repeats/itemList/ItemList";
import SideGallery from "../repeats/sideGallery/SideGallery";
import PersonalDetails from "../repeats/personalDetails/PersonalDetails";
import Cubes from "./Cubes";
import { addOrder, saveOrder } from "../../redux/API/order/order.action";

import galleryImg1 from "../../assets/images/PS/912_0126.jpg";
import galleryImg2 from "../../assets/images/PS/Boost_18_1101_149.jpg";
import galleryImg3 from "../../assets/images/PS/Stokado_Self_Storage1lr-768x512-jpg.jpg";
import galleryImg4 from "../../assets/images/PS/businessStorage.jpg";
import galleryImg5 from "../../assets/images/PS/maxresdefault.jpg";
import galleryImg6 from "../../assets/images/PS/privateStorage.jpg";
import online from "../../assets/images/PS/online.jpg";
import "./Storage.css";
import {
  getProductsByCategoryId,
  getProductCategories,
} from "../../redux/API/productCategories/productCategories.action";
import { modifyLocalForm } from "../../redux/local/form.action";
import logo from "../nav/Logo";

const LEAD_SOURCE = "הזמנת אחסנה אונליין";

const galleryArr = [
  {
    img: galleryImg1,
  },
  {
    img: galleryImg2,
  },
  {
    img: galleryImg3,
  },
  {
    img: galleryImg4,
  },
  {
    img: galleryImg5,
  },
  {
    img: galleryImg6,
  },
];

const radios = [
  {
    name: "לפי קוב",
    desc: "תמחור מיידי לאחסנה בלבד",
    incl: "",
    value: "cubes",
  },
  {
    name: "לפי פריטים",
    desc: "תמחור מיידי לאחסנה והובלה",
    incl: "(כולל מחשבון קוב)",
    value: "items",
  },
];

const OnlineStorage = ({ mainLogo }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const BOXES_CATEGORY_ID = process.env.REACT_APP_BOXES_CATEGORY_ID;
  const STORAGE_CATEGORY_ID = process.env.REACT_APP_STORAGE_CATEGORY_ID;
  const DELIVERY_CATEGORY_ID = process.env.REACT_APP_DELIVERY_CATEGORY_ID;
  const availableVolumes = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  const [validated, setValidated] = useState(false);

  const [volume, setVolume] = useState(0);
  const form = useSelector((state) => state.form);
  const [state, setState] = useState({
    ...form,
    flexibleDate: "no",
    source: LEAD_SOURCE,
  });
  const [cart, setCart] = useState(form.cart ?? []);
  const [radioValue, setRadioValue] = useState("items");
  const [cubes, setCubes] = useState([]);
  const [start, setStart] = useState(true);
  const [storage, setStorage] = useState({});
  const [isToDate, setIsToDate] = useState(false);
  const [isAddMoving, setIsAddMoving] = useState(false);
  const [movingFromAdress, setMovingFromAdress] = useState("");
  const products = useSelector(
    (state) => state.productCategories.productsCategoryById
  );

  const storages = useSelector((state) =>
    state.productCategories.productCategories.filter(
      (storage) => storage.parent === 2
    )
  );
  const categories = useSelector((state) =>
    state.productCategories.productCategories.filter(
      (category) => category.parent === 1
    )
  );
  const isServices = false;
  const isProductsCategoryPending = useSelector(
    (state) => state.productCategories.isProductsCategoryPending
  );

  // useEffect(() => {
  //   if (start) document.querySelector(".homeTitle").scrollIntoView();
  //   setStart(false);
  // }, [start]);

  const handleProducts = (newCart) => {
    const boxId = state.extraFields?.box;
    if (boxId) {
      const boxInCart = newCart.find((item) => item.entityId === Number(boxId));
      if (boxInCart && boxInCart.entityId !== boxId) {
        setState({
          ...state,
          extraFields: {
            ...state.extraFields,
            box: boxInCart.entityId,
          },
        });
      }
      if (!boxInCart) {
        setState({
          ...state,
          extraFields: {
            ...state.extraFields,
            box: null,
          },
        });
      }
    }
    return setCart(newCart);
  };

  useEffect(() => {
    if (state.extraFields && state.extraFields["box"]) {
      const boxes = products[process.env.REACT_APP_BOXES_CATEGORY_ID];
      const boxIds = boxes.map((box) => box.entityId);

      let cartWithoutBoxes = cart.filter(
        (item) => !boxIds.includes(item.entityId)
      );
      let obj = boxes.find(
        (item) => item.entityId === Number(state.extraFields["box"])
      );

      setCart([...cartWithoutBoxes, obj]);
    }
    if (state.extraFields && state.extraFields["box"] === null) {
      const boxes = products[process.env.REACT_APP_BOXES_CATEGORY_ID];
      const boxIds = boxes.map((box) => box.entityId);

      let cartWithoutBoxes = cart.filter(
        (item) => !boxIds.includes(item.entityId)
      );

      setCart(cartWithoutBoxes);
    }
  }, [state?.extraFields?.box, products]);

  useEffect(() => {
    setVolume(
      cart.reduce(
        (acc, item) =>
          acc + (Number(item.attributeValues.volume) || 1) * (item.number || 1),
        0
      )
    );
  }, [cart]);

  useEffect(() => {
    setState({
      ...state,
      extraFields: {
        ...state.extraFields,
        isAddmoving: isAddMoving,
      },
    });
  }, [isAddMoving]);

  useEffect(() => {
    let suitableVolume;
    for (let i in availableVolumes) {
      if (availableVolumes[i] >= volume) {
        suitableVolume = availableVolumes[i];
        break;
      }
    }
    const filteredProducts = storages
      .flatMap((storage) => storage.products)
      .filter((product) => product.extraFields.area === state.area || "מרכז")
      .filter((product) => product.title.includes(` ${suitableVolume} `));
    const selectedStorage =
      filteredProducts.length > 0 ? filteredProducts[0] : null;

    setStorage(selectedStorage);
  }, [volume]);

  useEffect(() => {
    if (!isProductsCategoryPending) {
      dispatch(getProductCategories());
      dispatch(getProductsByCategoryId(BOXES_CATEGORY_ID));
      dispatch(getProductsByCategoryId(STORAGE_CATEGORY_ID));
    }
  }, []); // eslint-disable-line

  const handleExtraFieldChange = (e) => {
    if (e.target.name === "timemoveflexible") {
      setState({
        ...state,
        extraFields: {
          ...state.extraFields,
          [e.target.name]: e.target.checked,
        },
      });
    } else {
      setState({
        ...state,
        extraFields: {
          ...state.extraFields,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  const onAddOrder = (e) => {
    e.preventDefault();
    const products = [];
    if (e.currentTarget.checkValidity() === false) {
      e.stopPropagation();
    } else if (
      radioValue === "items" &&
      (!cart.length || (cart.length === 1 && cart[0].entityId === 277130))
    ) {
      alert("נא לבחור לפחות פריט אחד");
      setStart(true);
      e.stopPropagation();
    } else if (!volume) {
      alert("נא לבחור גודל מחסן");
      e.stopPropagation();
    } else {
      dispatch(
        modifyLocalForm({
          ...state,
          storage,
          price: storage.price,
          volume: volume,
          cart,
          isItems: radioValue === "items",
        })
      );
      navigate("/storagesummary");
    }
  };

  const onChange = (value) => {
    setState({
      ...state,
      ...value,
    });
    if (value.name) {
      setState({
        ...state,
        extraFields: {
          ...state.extraFields,
          name: value.name,
        },
      });
    }
  };

  const onChangeExtraField = (e) => {
    setState({
      ...state,
      extraFields: {
        ...state.extraFields,
        [e.target.name]: e.target.value,
      },
    });
  };

  const onDateChange = (date, field) => {
    const parsedDate = parseISO(date);
    setState({ ...state, [field]: date });
  };

  useEffect(() => {
    let cubeArr = [...storages];
    cubeArr = cubeArr.sort(function (a, b) {
      return a.id - b.id;
    });

    setCubes(cubeArr);
    //eslint-disable-next-line
  }, [products]);

  const handleOnPlaceSelected = (place, inputRef, header) => {
    setMovingFromAdress(inputRef.value);
  };

  useEffect(() => {
    setState({
      ...state,
      extraFields: {
        ...state.extraFields,
        fromaddress: movingFromAdress,
      },
    });
  }, [movingFromAdress]);

  return (
    <>
      {/* <div className="page_banner">
        <img src={online} alt="" />
        <div className="banner_content">
          <div className="banner_title">
            <h1>הזמנת אחסנה אונליין</h1>
            <p>רק למלא פרטים ולשלוח</p>
          </div>
          <div className="btnDiv">
            <MainBtn text="חזרה" link="/privatestorage" />
            <MainBtn
              text="הזמנה בעזרת נציג"
              link="/getbackstorage"
              isLight={true}
            />
          </div>
        </div>
      </div>

      <Pros /> */}

      <div className="servicesDiv">
        <h1 className="homeTitle">פרטי הזמנה</h1>
        <div className="splitDiv">
          {/* <div className="imagesSide">
            <SideGallery
              mainImg={mainLogo}
              header="אחסנה פרטית"
              galleryArr={galleryArr}
            />
          </div> */}

          <div className="formSide">
            <Form
              className="formBox"
              validated={validated}
              onSubmit={onAddOrder}
            >
              <Row className="mb-3 row">
                <Form.Group as={Col} className="mb-3" controlId="formBasicName">
                  <Form.Label className="fw-semibold mb-2">
                    בחר אזור אחסנה רצוי
                  </Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    name="area"
                    required
                    onChange={onChange}
                  >
                    <option value="מרכז">מרכז</option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    נא לבחור אזור
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row className="mb-3 row">
                <Form.Label className="fw-semibold mb-2">נפח</Form.Label>

                <ButtonGroup className="mb-3 radio">
                  {radios.map((radio, i) => (
                    <ToggleButton
                      key={i}
                      id={`radio-${i}`}
                      type="radio"
                      variant={i % 2 ? "outline-warning" : "outline-warning"}
                      name={radio.name}
                      value={radio.value}
                      checked={radioValue === radio.value}
                      onChange={(e) => setRadioValue(e.currentTarget.value)}
                      style={{ width: "50%" }}
                    >
                      <h1 className="toggleHeader">{radio.name}</h1>
                      {/* <p>{radio.desc}</p> */}
                      <p>{radio.incl}</p>
                    </ToggleButton>
                  ))}
                </ButtonGroup>
              </Row>

              {radioValue === "items" ? (
                <ItemList
                  products={products[DELIVERY_CATEGORY_ID] || []}
                  cart={cart}
                  // showProductsImmediately
                  categories={categories}
                  handleProducts={handleProducts}
                  boxes={products[BOXES_CATEGORY_ID] || []}
                  onChange={onChangeExtraField}
                  isServices={isServices}
                />
              ) : (
                <Cubes
                  storage={cubes || []}
                  onChange={(newValue) => setVolume(newValue.volume)}
                />
              )}
              {radioValue === "items" ? (
                <Row className="mb-3 row">
                  <Form.Group className="mb-3 text" controlId="formBasicList">
                    <Form.Label className="fw-semibold mb-2">
                      הוספת פריט שאינו ברשימה:
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      placeholder="פרט כאן..."
                      name="note"
                      onChange={handleExtraFieldChange}
                    />
                  </Form.Group>
                </Row>
              ) : null}
              <Row className="mb-3 row">
                <Form.Group
                  as={Col}
                  className="mb-3"
                  controlId="formBasicMoving"
                >
                  <Form.Check
                    reverse
                    type="checkbox"
                    label="הוספת שירותי הובלה"
                    variant="warning"
                    onChange={() => setIsAddMoving(!isAddMoving)}
                  />
                </Form.Group>
              </Row>
              {isAddMoving && (
                <AddMoving
                  values={state}
                  header="מהיכן?"
                  withKindOfMoving={true}
                  handleExtraFieldChange={handleExtraFieldChange}
                  handleOnPlaceSelected={handleOnPlaceSelected}
                />
              )}
              <Form.Group as={Col} className="mb-3" controlId="formBasicEmail">
                <Form.Label className="fw-semibold mb-2">
                  תאריך תחילת אחסנה רצוי
                </Form.Label>
                <DatePicker
                  name="storageDateFrom"
                  dateFormat="dd-MM-yyyy"
                  placeholderText="בחר תאריך"
                  minDate={new Date()}
                  selected={
                    state?.storageDateFrom
                      ? new Date(state?.storageDateFrom)
                      : ""
                  }
                  onChange={(date) =>
                    onDateChange(format(date, "yyyy-MM-dd"), "storageDateFrom")
                  }
                  customInput={
                    <Form.Control
                      readOnly
                      autoComplete="off"
                      autoCorrect="off"
                      name="storageDateFrom"
                    />
                  }
                  locale={he}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  נא לבחור תאריך
                </Form.Control.Feedback>
                <Form.Check
                  reverse
                  type="checkbox"
                  label="גמיש"
                  variant="warning"
                  name="flexibleDate"
                  onChange={(e) =>
                    setState({
                      ...state,
                      [e.currentTarget.name]: e.currentTarget.checked
                        ? "yes"
                        : "no",
                    })
                  }
                />
                {state.storageDateFrom && (
                  <>
                    {" "}
                    <Form.Check
                      reverse
                      type="checkbox"
                      label="האם יש לך תאריך יציאה מאחסנה?"
                      variant="warning"
                      onChange={() => setIsToDate(!isToDate)}
                    />
                    {isToDate && (
                      <>
                        <Form.Label className="fw-semibold mb-2">
                          תאריך סיום אחסנה
                        </Form.Label>
                        <DatePicker
                          name="storageDateTo"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="בחר תאריך"
                          minDate={
                            state?.storageDateFrom
                              ? new Date(state?.storageDateFrom)
                              : new Date()
                          }
                          selected={
                            state?.storageDateTo
                              ? new Date(state?.storageDateTo)
                              : ""
                          }
                          onChange={(date) =>
                            onDateChange(
                              format(date, "yyyy-MM-dd"),
                              "storageDateTo"
                            )
                          }
                          customInput={
                            <Form.Control
                              readonly
                              autocomplete="off"
                              autoCorrect="off"
                              type="text"
                              name="storageDateTo"
                            />
                          }
                          locale={he}
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          נא לבחור תאריך
                        </Form.Control.Feedback>
                      </>
                    )}
                  </>
                )}
              </Form.Group>
              <PersonalDetails onChange={onChange} values={state} />
              <Button
                style={{
                  background: "var(--primary)",
                  border: "none",
                  width: "100%",
                }}
                text="שליחה"
                type="submit"
                className="filter-btn"
              >
                קבל הצעת מחיר
              </Button>
            </Form>
          </div>
        </div>
      </div>

      {/* <Reviews />
      <Footer /> */}
    </>
  );
};

export default OnlineStorage;
